import React from "react";

const LongerTextTableCell = ({ value, maxLength = 10, onClick }) => {
    const displayText = value
        ? value.length > maxLength
            ? value.substring(0, maxLength) + "..."
            : value
        : "-";

    return (
        <td
            style={{ cursor: "pointer", textDecoration: "underline" }}
            title={value || "-"}
            onClick={onClick}
        >
            {displayText}
        </td>
    );
};

export default LongerTextTableCell;